import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { LottieModule } from 'ngx-lottie';
import { LoadingComponent } from '.';


@NgModule({
  declarations: [
    LoadingComponent,
  ],
  imports: [
    CommonModule,
    LottieModule,
  ],
  exports: [
    LoadingComponent,
  ],
})
export class LoadingModule {
}
